module.exports = __webpack_public_path__ + "static/media/BlueButterfly.ae543e34.ico";